import { render, staticRenderFns } from "./skySlogan.vue?vue&type=template&id=5a6f1d88&scoped=true"
import script from "./skySlogan.vue?vue&type=script&lang=js"
export * from "./skySlogan.vue?vue&type=script&lang=js"
import style0 from "./skySlogan.vue?vue&type=style&index=0&id=5a6f1d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6f1d88",
  null
  
)

export default component.exports